import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, BarChart3, LayoutGrid, HelpCircle, CreditCard, LogOut, FlaskConical, ChevronRight, Zap, Briefcase } from 'lucide-react';
import MobileSheet from '../shared/MobileSheet';

/**
 * MoreMenuSheet — opened from the "More" tab in MobileBottomNav.
 * Lists the secondary routes that don't fit in the four-tab nav.
 */
export default function MoreMenuSheet({ isOpen, onClose }) {
  const navigate = useNavigate();

  const go = (path) => {
    onClose?.();
    navigate(path);
  };

  const handleLogout = () => {
    onClose?.();
    try {
      localStorage.removeItem('authToken');
    } catch (e) { /* noop */ }
    navigate('/login');
  };

  const items = [
    { key: 'portfolio',        icon: Briefcase,   label: 'Portfolio',         onClick: () => go('/portfolio') },
    { key: 'zerodte',          icon: Zap,         label: '0DTE Screener',     onClick: () => go('/0dte') },
    { key: 'profile',          icon: User,        label: 'Profile',           onClick: () => go('/profile') },
    { key: 'stock-analyzer',   icon: BarChart3,   label: 'Stock Analyzer',    onClick: () => go('/stock-analyzer') },
    { key: 'dashboard-builder',icon: LayoutGrid,  label: 'Dashboard Builder', onClick: () => go('/dashboard-builder') },
    { key: 'research',         icon: FlaskConical,label: 'Research',          onClick: () => go('/research') },
    { key: 'subscription',     icon: CreditCard,  label: 'Subscription',      onClick: () => go('/subscription') },
    { key: 'help',             icon: HelpCircle,  label: 'Help',              onClick: () => go('/profile') },
    { key: 'logout',           icon: LogOut,      label: 'Sign out',          onClick: handleLogout, danger: true },
  ];

  return (
    <MobileSheet isOpen={isOpen} onClose={onClose} title="More">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map(({ key, icon: Icon, label, onClick, danger }) => (
          <button
            key={key}
            type="button"
            onClick={onClick}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              padding: '14px 6px',
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid rgba(255,255,255,0.06)',
              color: danger ? '#f87171' : '#ffffff',
              fontSize: 15,
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <Icon size={20} style={{ flexShrink: 0, opacity: 0.85 }} />
            <span style={{ flex: 1 }}>{label}</span>
            <ChevronRight size={16} style={{ opacity: 0.4 }} />
          </button>
        ))}
      </div>
    </MobileSheet>
  );
}
